module.exports = __webpack_public_path__ + "static/resaleReport-coverDivider-v2-5496d026855b7fcf718b8bc577b0c56b.mp4";